require('./app.css');
require('babel-polyfill');

/* eslint-disable no-unused-vars*/
/* eslint-disable no-console*/

/* is production */
const isProd = process.env.NODE_ENV === 'production';
let devPref = isProd ? '' : '/';


/* data */
const data = require('./js/data.json');

/* analytics */
const analytics = require('universal-ga');
/*
analytics.initialize('UA-12345-3');
analytics.create('UA-12345-5', 'clientTracker');
*/

analytics.initialize(data.meta.trackingID);
analytics.pageview('/index');

if (data.meta.clientTrackingID.length > 0) {
    analytics.create(data.meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (data.meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

analyticsEvent('Page', 'load', {eventLabel: 'Successfully'});

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    // navigator.serviceWorker.register('./sw.js');
}

/* likes */
var likely = require('../node_modules/ilyabirman-likely/release/likely.js');

/* rellax */
const Rellax = require('rellax');
let rellaxReload = () => {
    let rlx = document.getElementsByClassName('rellax');
    if (rlx[0]) {
        new Rellax('.rellax', {
            speed: 2,
            round: true
        });
    }
}
rellaxReload();

/* in view */
const inView = require('in-view');

let refreshInView = () => {
inView('.number')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })
    .on('exit', elem => {
        elem.removeAttribute('data-inview');
    });


inView('.pic')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })
    .on('exit', elem => {
        elem.removeAttribute('data-inview');
    });

inView('.quote')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })
    .on('exit', elem => {
        elem.removeAttribute('data-inview');
    });

inView('.casetext')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })
    .on('exit', elem => {
        elem.removeAttribute('data-inview');
    });

inView('.article_item')
    .on('enter', elem => {
        elem.setAttribute('data-inview', 'true');
    })
    .on('exit', elem => {
        elem.removeAttribute('data-inview');
    });
}

refreshInView();


let appInTransition = false;
let mainBlocks = document.getElementsByClassName('article');
let mainBlock = mainBlocks[0];

let initNewBlock = () => {
    mainBlocks = document.getElementsByClassName('article');
    let mainBlock = mainBlocks[0];
    let newBlock = mainBlock.cloneNode(true);
    newBlock.innerHTML = '';
    newBlock.classList.add('newblock');
    mainBlock.classList.add('mainblock');
    mainBlock.parentNode.insertBefore(newBlock, mainBlock);
}

let swipeBlocks = (content) => {    
    mainBlocks = document.getElementsByClassName('article');
    let newMainBlock = mainBlocks[0];
    let oldMainBlock = mainBlocks[1];
    newMainBlock.innerHTML = content; 
    setTimeout(function() {
        window.scroll(0,0);
     }, 500);

    
    if (oldMainBlock) {
    stopSidemenuWatch();    
    appInTransition = true;
    oldMainBlock.classList.add('pt-page-moveToLeftEasing'); 
    newMainBlock.classList.add('pt-page-moveFromRight');

    setTimeout(function() {
        oldMainBlock.innerHTML = '';
        oldMainBlock.remove(); 
     }, 1000);        
    }

    setTimeout(function() {
        closeCurtain();        
        newMainBlock.classList.remove('pt-page-moveFromRight');        
        newMainBlock.classList.remove('newblock');
        appInTransition = false;
     }, 2000);
   
}

/* load mainpage */

let showIndex = () => {
    
    mainBlock.innerHTML = "";
    document.body.setAttribute("data-state", "index");
    document.body.setAttribute("data-platform", "");
    
    let head = `<div class="head">
    <h2 class="head__logo"><a href="/" data-navigo>SAP</a></h2>
    <h3 class="head__platform index_lenta"><a href="//lenta.ru">Lenta</a></h3>
    <h3 class="head__platform index_gazeta"><a href="//gazeta.ru">Gazeta</a></h3>
    <h3 class="head__platform index_secret"><a href="//secretmag.ru">Secret</a></h3>
    <div id="header-share" class="sharing"><div id="share-open-button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 481.6 481.6" style="enable-background:new 0 0 481.6 481.6;" xml:space="preserve">
<g>
    <path style="" d="M381.6,309.4c-27.7,0-52.4,13.2-68.2,33.6l-132.3-73.9c3.1-8.9,4.8-18.5,4.8-28.4
        c0-10-1.7-19.5-4.9-28.5l132.2-73.8c15.7,20.5,40.5,33.8,68.3,33.8c47.4,0,86.1-38.6,86.1-86.1S429,0,381.5,0s-86.1,38.6-86.1,86.1
        c0,10,1.7,19.6,4.9,28.5l-132.1,73.8c-15.7-20.6-40.5-33.8-68.3-33.8c-47.4,0-86.1,38.6-86.1,86.1s38.7,86.1,86.2,86.1
        c27.8,0,52.6-13.3,68.4-33.9l132.2,73.9c-3.2,9-5,18.7-5,28.7c0,47.4,38.6,86.1,86.1,86.1s86.1-38.6,86.1-86.1
        S429.1,309.4,381.6,309.4z M381.6,27.1c32.6,0,59.1,26.5,59.1,59.1s-26.5,59.1-59.1,59.1s-59.1-26.5-59.1-59.1
        S349.1,27.1,381.6,27.1z M100,299.8c-32.6,0-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1S132.5,299.8,100,299.8z
         M381.6,454.5c-32.6,0-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1S414.2,454.5,381.6,454.5z"/>
</g>
</svg></div><div class="likely likely-big likely-light likely_visible likely_ready" data-url="${data.meta.url}" data-title="${data.meta.headtitle}">
    <div class="vkontakte" tabindex='0', role='link', aria-label='Поделиться в VK'></div>
    <div class="facebook" tabindex='0', role='link', aria-label='Поделиться в Facebook'></div>
    <div class="twitter" tabindex='0', role='link', aria-label='Твитнуть'></div>    
    </div></div>
    </div>`;

    let bArticles = '';
    let allArticles = data.main.articles;
    for (let i = 0;  i < allArticles.length; i++) {
        let contentItem = allArticles[i];
        let oneArticle = `
        <div class="best_article ${contentItem.id}">
            <a href="${contentItem.link}" class="mobilefulscreenlink" data-navigo></a>
            <div class="best_article__inner">
                <div class="best_article__background" style="background: url('${contentItem.img}') center center no-repeat; background-size: cover">
                    
                </div>
                <div class="best_article__base">
                    <div class="best_article__base__number">${contentItem.number}</div>
                    <hr>
                    <div class="best_article__base__name">${contentItem.name}</div>
                </div>
                <div class="best_article__hover">
                    <div class="best_article__base__number">${contentItem.number}</div>
                    <hr>
                    <div class="best_article__base__name">${contentItem.name}</div>
                    <div class="best_article__base__description">${contentItem.desc}</div>
                    <a class="button hollow" href="${contentItem.link}" data-navigo>читать статьи</a>
                </div>
            </div>
        </div>
        `;
        bArticles += oneArticle;
    }

    let mainselector =`
    <div class="main_selector">
        <div class="main_selector__headtext">
            <h1>${data.main.header}</h1>
            <p>${data.main.headtitle}</p>
        </div>
        <div class="main_selector__best_articles">
        ${bArticles}
        <div class="overlay"></div>
        <div class="bgoverlay"></div>
        </div>
    </div>
    `;
    let content = '<header class="header">'+ head + mainselector + '</header>';
    
    /*
    mainBlock.innerHTML = content;
    */
    swipeBlocks(content);

    let topShareTrigger = document.getElementById('share-open-button');
    let shareMenu = document.getElementById('header-share');
    topShareTrigger.addEventListener("click", function() {
        topShareTrigger.classList.toggle('open');
        shareMenu.classList.toggle('open');
    })

    
    

    /*
    let mblocks = document.querySelectorAll(".best_article");
    for (let mblock in mblocks) {
        let heightBlock = mblocks[mblock].clientHeight;
        mblocks[mblock].style.height = heightBlock + "px";
    }
    */

    /*

    let articlesBlock = document.querySelectorAll('.best_article');

    for (let i in articlesBlock) {
        console.log(articlesBlock[i])
        articlesBlock[i].addEventListener("mouseover", function() {
            articlesBlock.style.opacity = '0';
        })
    }
   
    gslinks[i].addEventListener("mouseover", function() {router.pause()})
    gslinks[i].addEventListener("mouseout", function() {router.resume()})
    */

    
    likely.initiate();

    let shareContainers = document.querySelectorAll('.likely'); 
    shareLinksGa(shareContainers);
/*
    refreshInView();        
    window.scroll(0,0);
    */
    refreshInView();
    router.updatePageLinks();
    closeCurtain(2000);

}


let getHeaderSource = (platform) => {
    let platformLinkOuter = '';
    switch (platform) {
      case "lenta":
        platformLinkOuter = '<h3 class="head__platform index_lenta"><a href="//lenta.ru">Lenta</a></h3>';
        break;
      case "gazeta":
        platformLinkOuter = '<h3 class="head__platform index_gazeta"><a href="//gazeta.ru">Gazeta</a></h3>';
        break;
      case "secretmag":
        platformLinkOuter = '<h3 class="head__platform index_secret"><a href="//secretmag.ru">Secret</a></h3>';
        break;
      default:
        platformLinkOuter = '<h3 class="head__platform index_lenta"><a href="//lenta.ru">Lenta</a></h3><h3 class="head__platform index_gazeta"><a href="//gazeta.ru">Gazeta</a></h3><h3 class="head__platform index_secret"><a href="//secretmag.ru">Secret</a></h3>';
    }
    return platformLinkOuter;
}


let getBlockTemplate = (type, number, index) => {
    let result ='';

    switch (type) {
        case 'title': {
            result = ''; 
            if (index.title) {
                if (index.titleMargin) {
                    result += '<div class="marginblock"></div>';
                }
            result += `<h2 class="title">${index.title}</h2>`;
        } else {result = `` }
        break;}
        case 'quote': {
            if (index.quote) {
            result = `<blockquote class="quote"><span class="quote__inner">${index.quote}</span></blockquote>`;
        } else { result = `` }
        break;}
        case 'number': { 
            if (index.nonumber === true) {
                if (index.nomargin !== true) {
                result = '<div class="marginblock"></div>'
                }
            } else {
            result = `<h4 class="number" data-section="${number}"><span class="number__inner"><span class="number__text">${index.id}</span><span class="number__border"></span></span></h4>`;
            }
        break;}
        case 'wideImage': { 
            let image = new Image(); 
            image.src = devPref + index.images[0];
            if (index.case === true) {
                if( index.whitecase === true) {
                    if (index.casetitleWide === true) {
                        result = `<span class="pic pic--8 pic--case whitecase"><span class="pic__inner"><span class="casetext whitetext widetext"><span class="casetext--text">${index.casetitle}</span><span class="casetext--line"></span></span><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line pic__line--2"></span></span>`;  
                    } else {
                        result = `<span class="casetext whitetext"><span class="casetext--text">${index.casetitle}</span><span class="casetext--line"></span></span><span class="pic pic--8 pic--case whitecase"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line pic__line--2"></span></span>`;  
                    }
                } else {
                result = `<span class="casetext"><span class="casetext--text">${index.casetitle}</span><span class="casetext--line"></span></span><span class="pic pic--8 pic--case"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line pic__line--2"></span></span>`;
                }
            } else {
            result = `<span class="pic pic--8 pic--wide"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line pic__line--2"></span></span>`;
            }
        break;}
        case 'imageOneBackPic': { 
            let image = new Image(); 
            image.src = devPref + index.images[0]; 
            result = `<span class="pic pic--1 backpic"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line pic__line--1"></span><span class="pic__line pic__line--2"></span></span>`;
        break;}
        case 'imageOne': { 
            if (index.images[0]) {
                let image = new Image(); 
                image.src = devPref + index.images[0];
                
                if (index.intro) {
                    result = `<span class="pic pic--1 backpic"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line pic__line--1"></span><span class="pic__line pic__line--2"></span></span>`;
                } else {
                    result = `<span class="pic pic--1"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line pic__line--1"></span><span class="pic__line pic__line--2"></span></span>`;
                }
            } else {
                result = '';
            }
        break;}
        case 'firstTextBlock': {
            if (index.content[0]) { 
            result = `<p class="content" data-section="${number}" data-text="1">${index.content[0]}</p>`;
            } else {result = ``}
        break;}
        case 'secondTextBlock': { 
            if (index.content[1]) {
            result = `<p class="content" data-section="${number}" data-text="2">${index.content[1]}</p>`;
            } else {result = ``}
        break;} 
        case 'list': {
            if (typeof index.list !== 'undefined') {
                let header = '';
                if (index.list.header) {
                    header = `<b>${index.list.header}</b>`;
                }
                let list = index.list.content.reduce((mem, item) => mem + `<li>${item}</li>`, '');
            result += `<div class="content">${header}<ul data-section="${number}">${list}</ul></div>`;
            } else { result = `` }
            break;
        }      
        case 'thirdTextBlock': {
            if (index.content[2]) {
            result = `<p class="content" data-section="${number}" data-text="3">${index.content[2]}</p>`;
            } else {result = ``}
        break;}
        case 'fourthTextBlock': { 
            if (index.content[3]) {
            result = `<p class="content" data-section="${number}" data-text="4">${index.content[3]}</p>`;
        } else {result = ``}
        break;}
        case 'firstImgLeftTextBlock': {
            let image = new Image(); 
            image.src = devPref + index.images[0]; 
            result = `<div class="columns columns--1"><span class="pic pic--1 pic--aside pic--aside-left"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line"></span></span><p class="content content--withpic content--withpic-left" data-section="${number}" data-text="2">${index.content[1]}</p></div>`;
        break;}
        case 'secondImgLeftTextBlock': { 
            if (index.images[1]) {
            let image = new Image(); 
            image.src = devPref + index.images[1];
            result = `<div class="columns columns--1"><span class="pic pic--2 pic--aside pic--aside-left"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line"></span></span><p class="content content--withpic content--withpic-left" data-section="${number}" data-text="2">${index.content[1]}</p></div>`;
        } else { result =  ``}
        break;}
        case 'secondImgRightTextBlock': { 
            let image = new Image(); 
            image.src = devPref + index.images[1];
            result = `<div class="columns columns--2"><p class="content content--withpic content--withpic-right" data-section="${number}" data-text="3">${index.content[1]}</p><span class="pic pic--4 pic--aside pic--aside-right mobhide"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line"></span></span></div>`;
        break;}
        case 'thirdImgRightTextBlock': { 
            let image = new Image(); 
            image.src = devPref + index.images[1];
            result = `<div class="columns columns--2"><p class="content content--withpic content--withpic-right" data-section="${number}" data-text="3">${index.content[2]}</p><span class="pic pic--4 pic--aside pic--aside-right"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line"></span></span></div>`;
        break;}
        case 'bigTop': { 
            result = `<h2 class="title title--bg title--bg-8">${index.title}</h2>`;
        break;}
        case 'listTitle': { 
            result = `<h3 class="list-title">${index.list.title}</h3>`;
        break;}
        case 'listBody': { 
            let ourList = index.list.items;
            let listInner = '';
            for (let item in ourList) {
                listInner += `<li class="list__item">${ourList[item]}</li>`;
            }            
            result = `<ul class="list">${listInner}</ul>`;
        break;}
        case 'textImgRightText': { 
            let image = new Image(); 
            image.src = devPref + index.images[0];
            result = `<p class="content" data-section="${number}" data-text="1">${index.content[0]}</p><div class="columns columns--3"><p class="content content--withpic content--withpic-right" data-section="${number}" data-text="2">${index.content[1]}</p><span class="pic pic--9 pic--aside pic--aside-right"><span class="pic__inner"><img class="pic__img" src="${image.src}" alt=""></span><span class="pic__line"></span></span></div><p class="content" data-section="${number}" data-text="3">${index.content[2]}</p>`;
        break;}
        case 'marginblock': { 
            result = '<div class="marginblock"></div>'
        break;}
        default:

    }

    return result;
}

let getBlockContent = (type, index, order) => {
    let resultContent = '';

    switch (type) {
        case '1': {
            let imageOne = getBlockTemplate("imageOne", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgLeftTextBlock = getBlockTemplate("secondImgLeftTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += imageOne + title + firstTextBlock + secondImgLeftTextBlock + quote;
        break; }
        case '2': {
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgRightTextBlock = getBlockTemplate("secondImgRightTextBlock", order, index);            
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + number + title + firstTextBlock + secondImgRightTextBlock + quote;
        break; }
        case '3':{
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);     
            let quote = getBlockTemplate("quote", order, index);
                
            resultContent += number + title + firstTextBlock + secondTextBlock + quote + thirdTextBlock;
        
        break;}
        case '4': {
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            resultContent += wideImage + number + title + firstTextBlock + secondTextBlock + thirdTextBlock;
        
        break;}
        case '5':{
            let title = getBlockTemplate("title", order, index);
            let number = getBlockTemplate("number", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += number + title + firstTextBlock + quote;
        
        break;}
        case '6':{
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgLeftTextBlock = getBlockTemplate("secondImgLeftTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + number + title + firstTextBlock + secondImgLeftTextBlock + thirdTextBlock + quote;
        
        break;}
        case '7':{
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            let list = getBlockTemplate("list", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + number + title + firstTextBlock + secondTextBlock + list + quote;
        
        break;}
        case '8':{
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let firstImgLeftTextBlock = getBlockTemplate("firstImgLeftTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            resultContent += number + title + firstTextBlock + firstImgLeftTextBlock + thirdTextBlock;
        
        break;}
        case '9':{
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgRightTextBlock = getBlockTemplate("secondImgRightTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + number + title + firstTextBlock + secondImgRightTextBlock + thirdTextBlock + quote;
        
        break;}
        case '10':{
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);   
            let marginblock = getBlockTemplate("marginblock", order, index);         
            resultContent += marginblock + title + firstTextBlock;
        
        break;}
        case '11':{
            let bigTop = getBlockTemplate("bigTop", order, index);
            let listTitle = getBlockTemplate("listTitle", order, index);
            let listBody = getBlockTemplate("listBody", order, index);
            let textImgRightText = getBlockTemplate("textImgRightText", order, index);
            let quote = getBlockTemplate("quote", order, index);
            let fourthTextBlock = getBlockTemplate("fourthTextBlock", order, index);

            resultContent += bigTop + listTitle + listBody + textImgRightText + quote + fourthTextBlock;
        
        break;}
        case '12': {
            let imageOne = getBlockTemplate("imageOne", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgLeftTextBlock = getBlockTemplate("secondImgLeftTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            resultContent += imageOne + title + firstTextBlock + secondImgLeftTextBlock + thirdTextBlock;
        break; }
        case '13': {
            let wideImage = getBlockTemplate("wideImage", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            let thirdImgRightTextBlock = getBlockTemplate("thirdImgRightTextBlock", order, index); 
            let fourthTextBlock = getBlockTemplate("fourthTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + title + firstTextBlock + secondTextBlock + thirdImgRightTextBlock + fourthTextBlock + quote;
        break; }
        case '14': {
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            resultContent += wideImage + number + title + firstTextBlock + secondTextBlock;
        
        break;}
        case '15': {
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            resultContent = wideImage + number + title + firstTextBlock + quote + secondTextBlock;
        break; }
        case '16':{
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + number + title + firstTextBlock + quote + secondTextBlock;
        
        break;}
        case '17':{
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondTextBlock = getBlockTemplate("secondTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + number + title + firstTextBlock + quote + secondTextBlock + thirdTextBlock;
        
        break;}
        case '18': {
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgRightTextBlock = getBlockTemplate("secondImgRightTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += number + title + firstTextBlock + secondImgRightTextBlock + quote + thirdTextBlock;

            break;
        }
        case '19': {
            let wideImage = getBlockTemplate("wideImage", order, index);
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgLeftTextBlock = getBlockTemplate("secondImgLeftTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += wideImage + number + title + firstTextBlock + quote + secondImgLeftTextBlock + thirdTextBlock;

            break;
        }
        case '20': {
            let number = getBlockTemplate("number", order, index);
            let title = getBlockTemplate("title", order, index);
            let firstTextBlock = getBlockTemplate("firstTextBlock", order, index);
            let secondImgLeftTextBlock = getBlockTemplate("secondImgLeftTextBlock", order, index);
            let thirdTextBlock = getBlockTemplate("thirdTextBlock", order, index);
            let quote = getBlockTemplate("quote", order, index);
            resultContent += number + title + firstTextBlock + secondImgLeftTextBlock + quote + thirdTextBlock;

            break;
        }
        

        default:
        resultContent = 'no template';
    }
    return resultContent;
}

/* show article */

let sideMenuWatcher = () => {
    let navElem = document.getElementById('sideNavElem'); 
    let pyo = window.pageYOffset;
    let headElem = document.getElementsByClassName('header');
    let headElemHeight = headElem[0].clientHeight;

    if (pyo > headElemHeight) {
        navElem.style.opacity = 1;
    } else {
        navElem.style.opacity = 0;
    }
}

let showArticle = (params) => {
    /*
    openCurtain(2000);
    
    openCurtain();*/
    
    analyticsEvent('Page', 'load', {eventLabel: 'Открыт список статей машинного обучения'});

    mainBlock.innerHTML = '';
        gumshoe.destroy();


    let articleSource = params.source;
    let articleName = params.name;
    let source = data[articleSource];
    let article = source[articleName];
    
    document.body.setAttribute("data-state", "");
    document.body.setAttribute("data-platform", article.logo || articleSource);
    document.body.setAttribute("data-article", articleName);



    let platformLink = getHeaderSource(article.logo || articleSource);

    let head = `<div class="head">
        <h2 class="head__logo"><a href="/" data-navigo>SAP</a></h2>
        ${platformLink}
        <div id="header-share" class="sharing"><div id="share-open-button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 481.6 481.6" style="enable-background:new 0 0 481.6 481.6;" xml:space="preserve">
        <g>
            <path style="" d="M381.6,309.4c-27.7,0-52.4,13.2-68.2,33.6l-132.3-73.9c3.1-8.9,4.8-18.5,4.8-28.4
                c0-10-1.7-19.5-4.9-28.5l132.2-73.8c15.7,20.5,40.5,33.8,68.3,33.8c47.4,0,86.1-38.6,86.1-86.1S429,0,381.5,0s-86.1,38.6-86.1,86.1
                c0,10,1.7,19.6,4.9,28.5l-132.1,73.8c-15.7-20.6-40.5-33.8-68.3-33.8c-47.4,0-86.1,38.6-86.1,86.1s38.7,86.1,86.2,86.1
                c27.8,0,52.6-13.3,68.4-33.9l132.2,73.9c-3.2,9-5,18.7-5,28.7c0,47.4,38.6,86.1,86.1,86.1s86.1-38.6,86.1-86.1
                S429.1,309.4,381.6,309.4z M381.6,27.1c32.6,0,59.1,26.5,59.1,59.1s-26.5,59.1-59.1,59.1s-59.1-26.5-59.1-59.1
                S349.1,27.1,381.6,27.1z M100,299.8c-32.6,0-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1S132.5,299.8,100,299.8z
                M381.6,454.5c-32.6,0-59.1-26.5-59.1-59.1s26.5-59.1,59.1-59.1s59.1,26.5,59.1,59.1S414.2,454.5,381.6,454.5z"/>
        </g>
        </svg></div><div class="likely likely-big likely-light likely_visible likely_ready" data-url="https://sap.gazeta.ru/article/${articleSource}/${articleName}" data-title="${article.sharetitle}">
        <div class="vkontakte" tabindex='0', role='link', aria-label='Поделиться в VK', data-description="${article.descr}"></div>
        <div class="facebook" tabindex='0', role='link', aria-label='Поделиться в Facebook'></div>
        <div class="twitter" tabindex='0', role='link', aria-label='Твитнуть'></div>    
        </div></div>
        </div>`;

    let analyticsText = `Переход на статью ${article.title}`;
    analyticsEvent('Page', 'load', {eventLabel: analyticsText});

    let headTitle = `<h1 class="title">${article.title}</h1><span class="scrolldown"></span>`;

    let articleBlocksList = article.content;
    let articleBlocks = '';
    let sideNavContent = '';
    let IndexNumber = 0;

    /* перебираем блоки в статье */
    for (let index of articleBlocksList) {
        /* выясняем есть ли буквы на заднем фоне и добавляем если они есть */
        let letters = '';
        if (index.letters.length > 0) {
            let lettersArray = index.letters;
            for (let i = 0;  i < lettersArray.length; i++) {
                letters += `<span class="letter rellax" data-section="${IndexNumber+1}" data-letter="${i+1}">${lettersArray[i]}</span>`
            }
        }

        /* формируем блок боковой навигации внутри статьи */
        if (IndexNumber>0) {
        let pagelink = window.location.href;
        sideNavContent +=  `<li><a class="gslinks" href="${pagelink}#p${IndexNumber}" data-scroll>${IndexNumber}</a></li>`;
        }


        let articleType = index.blocktype;
        let blockContent = '';
        blockContent = getBlockContent(articleType, index, IndexNumber+1);

        let caseClass = '';
        if (index.case) {
            caseClass = 'case';
        }

        articleBlocks += `<section class="section ${caseClass}" id="p${IndexNumber}">${letters}${blockContent}</section>`;
        IndexNumber += 1;
    } 

    let sideShare = `<div class="sharing">
        <div class="likely" data-url="https://sap.gazeta.ru/article/${articleSource}/${articleName}" data-title="${source.meta.title}">
            <div class="vkontakte" tabindex="0" role="link" aria-label="Поделиться в VK">
            </div>
            <div class="facebook" tabindex="0" role="link" aria-label="Поделиться в Facebook">
            </div>
            <div class="twitter" tabindex="0" role="link" aria-label="Твитнуть">
            </div>            
        </div>
    </div>`
    let sideNav = ``;    
        sideNav = `<nav id="sideNavElem" class="nav"><button class="topbutton" onclick="window.scrollTo(0, 0);"></button><ul id="nav__sections" class="nav__sections" data-gumshoe="">${sideNavContent}<li></ul><div id="bottomNavTrigger"><div class="menu-icon" id="bottomNavTriggerIcon"><span></span></div></div>${sideShare}</nav>`;

    // debugger;
    let nextPageLinkName ='';
    let nextPageLinkSource ='';
    let parentArticleBlock = data.articles[article.type];
    let articlesLength = parentArticleBlock.length;
    for (let index in parentArticleBlock) {
        if (parentArticleBlock[index].link === articleName ) {
            let nextIndex = parseInt(index, 10) + 1;
            if (nextIndex > parentArticleBlock.length - 1) {
                nextIndex = 0;
            }
            nextPageLinkName = parentArticleBlock[nextIndex].link;
            nextPageLinkSource = parentArticleBlock[nextIndex].source
        }
    }
    let nextArticleButton = '';
    if (articlesLength > 1) {
        nextArticleButton = `<a href="/article/${nextPageLinkSource}/${nextPageLinkName}" class="button black hollow" data-navigo>Следующая статья</a>`;
    }
    let bottomAdditionalNav = '';
    bottomAdditionalNav = `<div class='bottom-add-nav'><a href="/" class="button black" data-navigo>На главную</a><a href="/${article.type}" class="button black hollow" data-navigo>Назад в рубрику</a>${nextArticleButton}</div>`;
    
    let randomLinks = '';
    let randomLinksInner = '';
    /* собираем пул всех статей для генератора "читайте дальше" */
    
    let allArts = [];
    Array.prototype.push.apply(allArts,data.articles['machine']);
    Array.prototype.push.apply(allArts,data.articles['iot']);
    Array.prototype.push.apply(allArts,data.articles['cloud']);
    Array.prototype.push.apply(allArts,data.articles['bigdata']); 

    allArts = allArts.filter((item) => {
        return !item.hidden;
    });

    articlesLength = allArts.length;

    /* Подбираем три статьи для пункта "читайте дальше" */
    
    let getRandomLinks = () => {

        // params;
        // data;
        // source;
        // article.type;

        let radnBlocks = '';
        let articlesCount = parseInt(articlesLength, 10);
        let randomNum = Math.floor(Math.random() * articlesCount) + 1;



        let activeCategoryArticles = data.articles[article.type];
        activeCategoryArticles = activeCategoryArticles.filter(item => {
            return item.link !== params.name && !item.hidden;
        });
        let otherCategoryArticles = (stopType => {
            let allTypes = ['machine', 'iot', 'cloud', 'bigdata'];
            allTypes = allTypes.filter(type => { return type !== stopType; });
            return allTypes.reduce((mem, item) => {
                return mem.concat(data.articles[item]);
            }, []);

        })(article.type);
        otherCategoryArticles = otherCategoryArticles.filter(item => {
            return !item.hidden;
        });
        otherCategoryArticles.sort((a,b) => {
            return Math.random() - 0.5;
        });


        let result = activeCategoryArticles.concat(otherCategoryArticles).slice(0, 3);

        for (let i = 0; i < result.length; i++) {

            let index = result[i];

            let image = new Image(); 
            image.src = devPref + index.img;

            radnBlocks += `<div class="article_item"><div class="article_item__inner"><a href="/article/${index.source}/${index.link}" data-navigo><div class="imageblock" style="background: url(${image.src}) center center no-repeat; background-size: cover;"></div><div class="text"><p class="article_name">${index.name}</p></div></div></a></div>`;
        }

        let randomLinksInnerClass = article.randomLinksInner ? `randomLinksInner--${article.randomLinksInner}` : '';
        randomLinksInner = `<div class="randomLinksInner ${randomLinksInnerClass}"><span>Читайте также</span><div class="inner-container">${radnBlocks}</div>` + bottomAdditionalNav + `</div>`;
    }

    if (articlesLength > 2) {
        getRandomLinks();
    }
    


    
    randomLinks += randomLinksInner;

    let headBg = article.headbg;
    let headBgOffsetClass = article.headbgoffset ? ' header--offset' : '';
    let image = new Image(); 
        image.src = devPref + article.headbg;
    let headContent = '<header class="header' + headBgOffsetClass + '" style="background-image: url(' + image.src + ');">' + head + headTitle +  '</header>';
    let mainContent = '<div class="main-container"><div class="main">' + articleBlocks  + '</div>' + randomLinks + sideNav ;

    let aboutBlockStat = ``;

    for (let item in data.about.stat) {
        aboutBlockStat += `<div class="stat"><h4 class="stat__name">${data.about.stat[item].name}</h4><p class="stat__desc">${data.about.stat[item].desc}</p></div>`;
    }

    

    let aboutBlock='';
        aboutBlock = `<aside class="about"><header class="about__header"><div class="container"><h3 class="logo"><a href="//sap.com" target="_blank" rel="noopener">SAP®</a></h3><h4 class="motto">${data.about.motto}</h4><a href="https://www.sap.com/cis/registration/contact.html" class="button hollow connectwithus" target="_blank">связаться с нами</a></div></header><div class="about__main"><h3 class="title">О компании SAP®</h3><p class="content"><b>SAP® SE</b>&nbsp;— мировой лидер разработки и&nbsp;внедрения программного обеспечения для трансформации бизнес процессов и&nbsp;бизнес моделей.</p><p class="content">Основные программные решения и&nbsp;направления: планирование основных ресурсов (ERP). Облачные платформы для бизнеса. Интернет вещей. Большие данные.</p></div><footer class="about__stat"><div class="container">${aboutBlockStat}</div></footer></aside>`;

    article;
    let footer = '';
        footer = `<footer class="footer">
    <h4 class="footer__logo"><a href="${article.footerlink || source.meta.footerlink}">${source.meta.copyright}</a></h4>
    <p class="footer__copyright">${source.meta.copyright}</p>
    <div class="sharing">
        <div class="likely" data-url="https://sap.gazeta.ru/?result=${articleName}" data-title="${source.meta.title}">
            <div class="facebook" tabindex="0" role="link" aria-label="Поделиться в Facebook">
            </div>
            <div class="twitter" tabindex="0" role="link" aria-label="Твитнуть">
            </div>
            <div class="vkontakte" tabindex="0" role="link" aria-label="Поделиться в VK">
            </div>
        </div>
    </div>
    </footer>`;

    let content = headContent + mainContent + aboutBlock + footer + '</div>';


    swipeBlocks(content);
       
    window.addEventListener("scroll", sideMenuWatcher );
    refreshInView();
    rellaxReload();
    router.updatePageLinks();
    likely.initiate();
    gumshoe.init({
        callback: function (nav) {
            let navcont = document.getElementById('nav__sections');
            if (nav) {
                let targetBlock = nav.target;
                let targetBlockId = targetBlock.id;
                let countNum = parseInt(targetBlockId.substring(1));
                navcont.setAttribute("data-attr", countNum)
            }
        }
    });

    let shareContainers = document.querySelectorAll('.likely'); 
    shareLinksGa(shareContainers);

    let navSelectorsGoogleAnal = document.querySelectorAll('.gslinks'); 
    navSelectorsGa(navSelectorsGoogleAnal);

    let connectWithUsLink = document.getElementsByClassName("connectwithus")[0];
    connectWithUsLink.addEventListener("click", function(){
        analyticsEvent('link', 'click', {eventLabel: "связаться с нами clicked"});
    })


    let bottomMenuTrigger = document.getElementById('bottomNavTriggerIcon');
    let bottomMenu = document.getElementById('nav__sections');
    bottomMenuTrigger.addEventListener("click", function() {
            bottomMenuTrigger.classList.toggle('open');
            bottomMenu.classList.toggle('open');
        })

    let topShareTrigger = document.getElementById('share-open-button');

    let shareMenu = document.getElementById('header-share');
    topShareTrigger.addEventListener("click", function() {
        topShareTrigger.classList.toggle('open');
        
        shareMenu.classList.toggle('open');
    }) 

    let gslinks = document.getElementsByClassName('gslinks');
    for ( let i = 0;  i < gslinks.length; i++) {
        gslinks[i].addEventListener("mouseover", function() {
            router.pause();
        })
        gslinks[i].addEventListener("mouseout", function() {
            router.resume();
        })
    } 
}

/* show page list */

const curtain = document.getElementById('transitionblock');

function findPos(obj) {
    let coors=obj.getBoundingClientRect();
    let finalCoords = coors.top + window.pageYOffset;
    return [finalCoords];
}

let showPagesList = (params) => {
    /*
    mainBlock.innerHTML = "";
    */
    document.body.setAttribute("data-state", "");
    document.body.setAttribute("data-platform", "");
    document.body.setAttribute("data-article", "");

    let list = data.articles[params];

    list = list.filter(item => {
        return !item.hidden;
    })

    let blocks = '';
    for (let index of list) {
        let image = new Image(); 
            image.src = devPref + index.img; 
    
      blocks += `<div class="article_item"><div class="article_item__inner"><a href="/article/${index.source}/${index.link}" data-navigo><div class="imageblock" style="background: url(${image.src}) center center no-repeat; background-size: cover;"></div><div class="text"><p class="article_name">${index.name}</p></div></div></a></div>`;
    }
    let headContent = '';
    let articlesList = data.main.articles;
    for (let index of articlesList){
        if (index.id === params) {
            let image = new Image(); 
            image.src = devPref + index.bgimg; 
            headContent = `<div class="listHead" style="background: url(${image.src}) center center no-repeat; background-size: cover;"><div class="column_header"><p class="number">${index.number}</p><hr><h4 class="header_name">${index.name}</h4><p class="header_descr">${index.desc}</p></div></div>`; 
        }
    }

    let listFooter = `<div class="list_footer"><a href="/" class="button black" id="gtt" data-navigo>На главную</a><button class="button black hollow" id="smbutton">Показать еще</button></div>`;
    
    let contentBlocks = `<div class="column">${blocks}</div>`;
    let lstftrcontent = `${listFooter}`;
    let emptyWarning = `<div id="emptywarning" class="column"><h2>Материалы в этом разделе появятся в самое ближайшее время.</h2></div>`;
    let content = '';
    content = `<div id="pageslist">${headContent}${emptyWarning}${contentBlocks}${listFooter}</div>`

    swipeBlocks(content); 

    /*
    window.scroll(0,0);
    */
    router.updatePageLinks()

    
    /*
    let goToTopButton = document.getElementById('gtt');
    goToTopButton.addEventListener('click', function() {
        gotoTop();
        /*
        setTimeout(function() {
            clearArticlesList();     
     }, 500);
     
    });*/

    let showMoreBtn = document.getElementById('smbutton');
    showMoreBtn.classList.add('hidden');
    showMoreBtn.addEventListener('click', function() {
        showMore();
    });

    let blocksList = document.getElementsByClassName('article_item');
    if (blocksList.length > 6) {showMoreBtn.classList.remove('hidden');}

    for (let i = 0;  i < blocksList.length; i++) {
        if (i>5) {
            blocksList[i].classList.add('hidden');
        }
    }

    let emptywarning = document.getElementById('emptywarning');
    if (blocksList.length === 0) {
        emptywarning.style.display = "block";
    }

    refreshInView();  
}

/*
let clearArticlesList = () => {
    let pagesListContainer = document.getElementById('pageslist');
    pagesListContainer.classList.remove('fullheight');
    pagesListContainer.innerHTML = '';
}
*/

let gotoTop = () => {
    /*
    openCurtain();
    */
    router.navigate('/');
    closeCurtain(2000); 
}

let showMore = () => {
    let blocksList = document.getElementsByClassName('article_item');
       for (let i = 0;  i < blocksList.length; i++) {
         blocksList[i].classList.remove('hidden');
        }
}

let stopSidemenuWatch = () => {
    let navElem = document.getElementById('sideNavElem');
    if(navElem) {window.removeEventListener("scroll", sideMenuWatcher );}
}

let openCurtain = () => {
    stopSidemenuWatch();
    curtain.classList.remove('hidden');
    curtain.classList.add('animateme');
}

let closeCurtain = (time) => {
    let timeCutter = time / 4;
    setTimeout(function() {
        curtain.classList.remove('animateme');                  
     }, 1000);
    
    
}

let gaShareClick = (source) => {
    let sharetext = 'share link click: source - ' + source;
    analyticsEvent('link', 'click', {eventLabel: sharetext});
}


let shareLinksGa = (sharecont) => {

    for (let shareList of sharecont) {      
        let shares = shareList.children;
        for (let item of shares) {
            if (item.classList.contains('likely__widget_facebook')){
                item.addEventListener("click", function(){gaShareClick("facebook")})
            }

            if (item.classList.contains('likely__widget_twitter')){
                item.addEventListener("click", function(){gaShareClick("twitter")})
            }

            if (item.classList.contains('likely__widget_vkontakte')){
                item.addEventListener("click", function(){gaShareClick("vkontakte")})
            }
        }      
    }

}


let navSelectorsGa = (navLinksGa) => {
    for (let link of navLinksGa) {
        let linkInnerText = link.innerHTML;
        let linkText = "page navigation link clicked: link number - " + linkInnerText;
        link.addEventListener("click", function(){ analyticsEvent('link', 'click', {eventLabel: linkText})})    
    }
}



/* gumshoe */
const gumshoe = require('gumshoe');

gumshoe.init();



/* scroll */
const SmoothScroll = require('smooth-scroll');

new SmoothScroll('a[href*="#"]');

/* navigo */


const Navigo = require('navigo');

const rootUrl = isProd ? data.meta.url : null;
const router = new Navigo(rootUrl, false, '#');

router.on({
    '/machine': (params) => {        
        initNewBlock();
        /*
        openCurtain();
        */
        setTimeout(function() {
            showPagesList('machine');
        }, 500);
        analyticsEvent('Page', 'load', {eventLabel: 'Открыт список статей машинного обучения'});
        /*
        closeCurtain(2000);
        */
        
    },
    '/bigdata': (params) => {
        initNewBlock();
        /*
        openCurtain();
        */
        setTimeout(function() {
            showPagesList('bigdata');
        }, 500);
        analyticsEvent('Page', 'load', {eventLabel: 'Открыт список статей Big Data'});
        /*
        closeCurtain(2000);
        */
        
    },
    '/cloud': (params) => {
        initNewBlock();
        /*
        openCurtain();
        */
        setTimeout(function() {
            showPagesList('cloud');
        }, 500);
        analyticsEvent('Page', 'load', {eventLabel: 'Открыт список статей облачных технологий'});
        /*
        closeCurtain(2000);
        */
        
    },    
    '/iot': (params) => {
        initNewBlock();
        /*
        openCurtain();
        */
        setTimeout(function() {
            showPagesList('iot');
        }, 500);
        analyticsEvent('Page', 'load', {eventLabel: 'Открыт список статей Интернет вещей'});
        /*
        closeCurtain(2000);
        */
        
    },
    '/article/:source/:name': (params) => {
        history.replaceState("", document.title, window.location.href + window.location.search, true);
        initNewBlock();
        let page = window.location.pathname + window.location.search;
        analytics.pageview(page);
        analytics.name('clientTracker').pageview(page);     
        /*       
        openCurtain();
        */
            setTimeout(function() {
            showArticle(params);
        }, 500);

        /*a
        closeCurtain(2000);
        */
    },
    // '*': (params) => {
    //     console.log('***');
    //     // router.navigate('/article/gazeta/selftuningsystems');
    //     // router.navigate('/article/lenta/bigmarketstime');
    //     // router.navigate('/article/lenta/mbankexperience');
    //     // router.navigate('/article/lenta/uralhimexperience');
    //     // router.navigate('/article/lenta/titansarecoming');
    //     router.navigate('/article/lenta/artificialintelligence');
    //     // router.navigate('/article/lenta/rosatomtransformation');
    //     // router.navigate('/article/lenta/swarovskitransformation');
    //     // router.navigate('/article/lenta/bigdatafortrenitalia');
    //     // router.navigate('/article/lenta/lightspeedmodernise');
    //     // router.navigate('/article/lenta/internetofthings');
    //     // router.navigate('/article/secretmag/blockademechanism');
    //     window.history.pushState('home', 'Home', '/');
    // }
    '*': function (params) {
            stopSidemenuWatch();
            showIndex();
            analyticsEvent('Page', 'load', {eventLabel: 'Переход на главную страницу'});
            analytics.pageview('/index');
            analytics.name('clientTracker').pageview('/index');  
    }
}).resolve();

/*
router.hooks({
  before: function(done, params) { 
    if(appInTransition) { done(false);} else { done()}
   }
});
*/



/* eslint-enable no-unused-vars*/
/* eslint-enable no-console*/



// WEBPACK FOOTER //
// ./app.js